import { enableAdminUserMERegistration } from "../../app/services/ME-user-registration-api/enableAdminUserMERegistration"
import { initializeAppInstanceMERegistration } from "../../app/services/ME-user-registration-api/initializeAppInstanceMERegistration"
import { verifyBasicVersionStatusMERegistration } from "../../app/services/ME-user-registration-api/verifyBasicVersionStatusMERegistration"
import { logEvent } from "../../utils/LogEvents"
import {
  setErrorTextSnackBar,
  setRequestTextSnackBar,
  setSuccessTextSnackBar,
} from "./app"

export const enabledBasicME = (data) => {
  return async (dispatch) => {
    try {
      const response = await initializeAppInstanceMERegistration(data)
      logEvent("CGI - initializeAppInstanceMERegistration", {
        currentData: data,
        resultData: response?.data,
      })
      dispatch(setRequestTextSnackBar())
      dispatch(
        setSuccessTextSnackBar("Mi Estudio Básico fue habilitado con éxito."),
      )
    } catch (error) {
      if (error.response?.status === 404) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            "Ocurrió un error en un servicio de: miestudio-user-registration-api",
          ),
        )
      }
      if (error.response?.data?.codeMessageLanguage) {
        dispatch(setRequestTextSnackBar())
        dispatch(setErrorTextSnackBar(error.response?.data?.data))
      }
      if (error.response?.data?.status === "Error") {
        return { status: "error", error: error.response?.data }
      }
      logEvent("CGI - initializeAppInstanceMERegistration", {
        currentData: data,
        error: error?.response?.data,
      })
      dispatch(setRequestTextSnackBar())
      dispatch(setErrorTextSnackBar("Ocurrió un error. Intente nuevamente."))
    }
  }
}

export const enableAdminUserME = (userId) => {
  return async (dispatch) => {
    try {
      const response = await enableAdminUserMERegistration(userId)
      logEvent("CGI - enableAdminUserMERegistration", {
        currentData: {
          userId,
        },
        resultData: response?.data,
      })
      dispatch(setRequestTextSnackBar())
      dispatch(
        setSuccessTextSnackBar(
          "El cambio de email de usuario administrador fue éxitoso.",
        ),
      )
    } catch (error) {
      logEvent("CGI - enableAdminUserMERegistration", {
        currentData: {
          userId,
        },
        error: error?.response?.data,
      })
      if (error.response?.status === 404) {
        dispatch(setRequestTextSnackBar())
        return dispatch(
          setErrorTextSnackBar(
            "Ocurrió un error en un servicio de: miestudio-user-registration-api",
          ),
        )
      }
      if (error.response?.data?.codeMessageLanguage) {
        dispatch(setRequestTextSnackBar())
        return dispatch(setErrorTextSnackBar(error.response?.data?.data))
      }
      if (error.response?.data?.status === "Error") {
        return { status: "error", error: error.response?.data }
      }

      dispatch(setRequestTextSnackBar())
      dispatch(setErrorTextSnackBar("Ocurrió un error. Intente nuevamente."))
    }
  }
}

export const verifyBasicVersionStatus = (organizationId) => {
  return async (dispatch) => {
    try {
      const response = await verifyBasicVersionStatusMERegistration(
        organizationId,
      )

      dispatch(setRequestTextSnackBar())
      dispatch(setSuccessTextSnackBar("Verificación finalizada éxitosamente"))
      return response.data
    } catch (error) {
      if (error.response?.status === 404) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            "Ocurrió un error en un servicio de: miestudio-user-registration-api",
          ),
        )
        return
      }
      if (error.response?.data?.codeMessageLanguage) {
        dispatch(setRequestTextSnackBar())
        dispatch(setErrorTextSnackBar(error.response?.data?.message))
      }
      if (error.response?.status === 500) {
        return error.response?.data
      } else {
        dispatch(setRequestTextSnackBar())
        dispatch(setErrorTextSnackBar("Ocurrió un error. Intente nuevamente"))
      }
    }
  }
}
